import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '../../global.service';
import { Service } from '../../services';
import {Router} from "@angular/router";

@Component({
  selector: 'app-tab-nav',
  templateUrl: './tab-nav.component.html',
  styleUrls: ['./tab-nav.component.sass']
})
export class TabNavComponent implements OnInit {

  @Output() updatePostpaid = new EventEmitter<boolean>();
  @Output() updatePrepaid = new EventEmitter<boolean>();
  @Output() updateFixed = new EventEmitter<boolean>();
  @Output() updateTotalAccountList = new EventEmitter<number>();
  @Output() changeTab2 = new EventEmitter<number>();
  @Output() updateCurrentList = new EventEmitter<any>();
  @Output() updateSelectBan = new EventEmitter<string>();
  @Output() updateInitializeData = new EventEmitter();
  @Output() updateType = new EventEmitter<string>();
  @Input() visible: boolean;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public prepaidAccounts;
  public postpaidAccounts;
  public fixedAccounts;
  public selectedLine;
  public runPrepaid;
  public currentList;
  public currentAccountType: string;
  public totalAccountList;
  public selectBan: any;
  public type;
  public token;
  public AccountInfo;
  public subscriber;
  public code;
  public region;
  public origin = "11";
  public selectBans;
  constructor(private services: Service, private global: GlobalService, private router: Router) { }

  ngOnInit() {
    if(this.global.validateSession()){
      this.selectBans = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      if (this.visible == undefined) {
        this.visible = true;
      }
      this.iniTabsNav();
    }
  }
  iniTabsNav() {
    this.postpago = false;
    this.prepago = false;
    this.telefoniaFijo = false;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.type = sessionStorage.getItem("tab");
    sessionStorage.setItem("currentBan", sessionStorage.getItem("selectBan"));
    sessionStorage.setItem("currentSuscriber", btoa(this.global.getSuscriberByDefault(this.selectBan)));
    this.postpaidAccounts = this.global.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'postpago');
    this.prepaidAccounts = this.global.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'prepago');
    this.fixedAccounts = this.global.fiterAccountBy(JSON.parse(atob(sessionStorage.getItem("AccountList"))), 'telefoniaFijo');
    this.totalAccountList = 0;
    //calculo de tipo de cuenta
    for (let i = 0; i < this.postpaidAccounts.length; i++) {
      if (this.postpaidAccounts[i].account == this.selectBan) {
        this.currentAccountType = 'postpaid';
      }
    }
    for (let i = 0; i < this.prepaidAccounts.length; i++) {
      if (this.prepaidAccounts[i].account == this.selectBan) {
        this.currentAccountType = 'prepaid';
      }
    }
    for (let i = 0; i < this.fixedAccounts.length; i++) {
      if (this.fixedAccounts[i].account == this.selectBan) {
        this.currentAccountType = 'fixed';
      }
    }
    //fin calculo de tupo de cuenta
    if (this.postpaidAccounts != '' && (this.type == 'postpago' || this.type == null) && this.currentAccountType == 'postpaid') {
      this.currentList = this.postpaidAccounts;
      this.postpago = true;
      this.totalAccountList = this.postpaidAccounts.length;
      sessionStorage.setItem("currentPostpaid", btoa(this.selectBan));
      sessionStorage.setItem("tab", "postpago");
    }
    else if (this.prepaidAccounts != '' && (this.type == 'prepago' || this.type == null) && this.currentAccountType == 'prepaid') {
      this.prepago = true;
      this.currentList = this.prepaidAccounts;
      this.totalAccountList = this.prepaidAccounts.length;
      sessionStorage.setItem("currentPrepaid", btoa(this.selectBan));
      sessionStorage.setItem("tab", "prepago");
    }
    else if (this.fixedAccounts != '' && (this.type == 'telefoniaFijo' || this.type == null) && this.currentAccountType == 'fixed') {
      this.telefoniaFijo = true;
      this.currentList = this.fixedAccounts;
      this.totalAccountList = this.fixedAccounts.length;
      sessionStorage.setItem("currentFixed", btoa(this.selectBan));
      sessionStorage.setItem("tab", "telefoniaFijo");
    }

    if (this.global.validateSession() == true) {
    this.token = sessionStorage.getItem("token");
    this.AccountInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    //this.subscriber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    let typeOfAccount = this.global.checkTypeAccount(this.AccountInfo["accountTypeField"], this.AccountInfo["accountSubtypeField"]);
    if (typeOfAccount == 'postpago') {
      this.code = "501";
      this.region = "Region 1";
    }
    else if (typeOfAccount == 'prepago') {
      this.code = "552";
      this.region = "Region 1";
    }
    else if (typeOfAccount == 'telefoniaFijo') {
      this.code = "553";
      this.region = "Region 1";
    }
    else {
      this.code = "599";
      this.region = "Region 1";
    }
    this.global.showSplahs(this.currentAccountType);
    /*
    if(sessionStorage.getItem("botChat")==null){
      this.services.botchat(sessionStorage.getItem("token"),sessionStorage.getItem("SSOAccessToken"), this.region, this.code, "e2f7386f-32d3-44ed-8088-0133d1191124", this.origin, this.AccountInfo["firstNameField"] + " " + this.AccountInfo["lastNameField"], this.selectBan, this.AccountInfo["emailField"], "Web", "").subscribe(data => {
        if (data.hasError == false) {
          this.global.urlChat = data.url;
          sessionStorage.setItem("botChat",this.global.urlChat);
        }
      });
    }
    else{
      this.global.urlChat=sessionStorage.getItem("botChat");
    }
    */
  }

    this.updatePostpaid.emit(this.postpago);
    this.updatePrepaid.emit(this.prepago);
    this.updateFixed.emit(this.telefoniaFijo);
    this.updateTotalAccountList.emit(this.totalAccountList);
    this.updateCurrentList.emit(this.currentList);
    this.updateSelectBan.emit(this.selectBan);
    this.updateType.emit(this.currentAccountType);
    this.global.updateTypeAccount(this.currentAccountType);
  }

  changeTab(tab, ini) {
    this.loadDataForChange(tab, ini);
  }

  loadDataForChange(tab, ini) {
    if (this.global.validateSession() === true) {
      sessionStorage.removeItem("splashActive");
      this.changeTab2.emit(1);
      let sw = true;
      let accountList: any = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      sessionStorage.setItem("currentBan", sessionStorage.getItem("selectBan"));
      sessionStorage.setItem("currentSuscriber", btoa(this.global.getSuscriberByDefault(sessionStorage.getItem("selectBan"))));
      if (tab == 'prepago') {
        this.code = "552";
        this.region = "Region 1";
        this.postpago = false;
        this.prepago = true;
        this.telefoniaFijo = false;
        this.totalAccountList = this.prepaidAccounts.length;
        if (this.prepaidAccounts.length > 0) {
          var swPost = 0;
          for (var i = 0; i < this.prepaidAccounts.length; i++) {
            if (this.prepaidAccounts[i].account == atob(sessionStorage.getItem("currentPrepaid"))) {
              this.selectBan = btoa(this.prepaidAccounts[i].account);
              sessionStorage.setItem("selectBan", btoa(this.prepaidAccounts[i].account));
              sessionStorage.setItem("currentPrepaid", btoa(this.prepaidAccounts[i].account));
              swPost = 1;
            }
          }
          if (swPost == 0) {
            this.selectBan = btoa(this.prepaidAccounts[0].account);
            sessionStorage.setItem("selectBan", btoa(this.prepaidAccounts[0].account));
          }

          for (let i = 0; i < accountList.length; i++) {
            var tipo_ = this.global.checkTypeAccount(accountList[i].accountType, accountList[i].accountSubType);
            if (tipo_ == 'prepago') {
              this.selectedLine = accountList[i].subsriberByDefault;
              sessionStorage.setItem("selectedLine", accountList[i].subsriberByDefault);

            }
            else {
              sessionStorage.setItem("selectedLine", sessionStorage.getItem("selectedLine"));
            }
            this.currentList = this.postpaidAccounts;
            this.prepago = true;
          }
          // this.botChat(tab);
          sessionStorage.setItem("tab", "prepago");
          this.updateInitializeData.emit();
          this.currentAccountType = 'prepaid';
        }
        else {
          // this.botChat(tab);
          sw = false;
        }
      }
      else if (tab == 'postpago') {
        this.code = "501";
        this.region = "Region 1";
        this.postpago = true;
        this.prepago = false;
        this.telefoniaFijo = false;
        this.totalAccountList = this.postpaidAccounts.length;

        if (this.postpaidAccounts.length > 0) {
          var swPost = 0;
          for (var i = 0; i < this.postpaidAccounts.length; i++) {

            if (this.postpaidAccounts[i].account == atob(sessionStorage.getItem("currentPostpaid"))) {
              this.selectBan = this.postpaidAccounts[i].account;
              sessionStorage.setItem("selectBan", btoa(this.postpaidAccounts[i].account));
              sessionStorage.setItem("currentPostpaid", btoa(this.postpaidAccounts[i].account));
              swPost = 1;
            }
          }
          if (swPost == 0) {
            this.selectBan = this.postpaidAccounts[0].account;
            sessionStorage.setItem("selectBan", btoa(this.postpaidAccounts[0].account));
          }

          for (let i = 0; i < accountList.length; i++) {
            var tipo_ = this.global.checkTypeAccount(accountList[i].accountType, accountList[i].accountSubType);
            if (tipo_ == 'postpago') {
              this.selectedLine = accountList[i].subsriberByDefault;
              this.currentList = this.postpaidAccounts;
              this.postpago = true;
            }
          }
          // this.botChat(tab);
          sessionStorage.setItem("tab", "postpago");
          this.updateInitializeData.emit();
          this.currentAccountType = 'postpaid';
        }
        else {
          // this.botChat(tab);
          sw = false;
        }
      }
      else if (tab == 'telefoniaFijo') {
        this.code = "553";
        this.region = "Region 1";
        this.postpago = false;
        this.prepago = false;
        this.telefoniaFijo = true;
        this.totalAccountList = this.fixedAccounts.length;
        var swFijo = 0;
        if (this.fixedAccounts.length > 0) {
          for (var i = 0; i < this.fixedAccounts.length; i++) {
            if (this.fixedAccounts[i].account == atob(sessionStorage.getItem("currentFixed"))) {
              this.selectBan = this.fixedAccounts[i].account;
              sessionStorage.setItem("selectBan", btoa(this.fixedAccounts[i].account));
              sessionStorage.setItem("currentFixed", btoa(this.fixedAccounts[i].account));
              swFijo = 1;
            }
          }
          if (swFijo == 0) {
            this.selectBan = this.fixedAccounts[0].account;
            sessionStorage.setItem("selectBan", btoa(this.fixedAccounts[0].account));
            this.selectBan = this.fixedAccounts[0].account;
          }
          for (let i = 0; i < accountList.length; i++) {
            var tipo_ = this.global.checkTypeAccount(accountList[i].accountType, accountList[i].accountSubType);
            if (tipo_ == 'telefoniaFijo') {
              this.telefoniaFijo = true;
              this.currentList = this.fixedAccounts;
            }
          }
          //this.botChat(tab);
          sessionStorage.setItem("tab", "telefoniaFijo");
          this.updateInitializeData.emit();
          this.currentAccountType = 'fixed';
        }
        else {
          //this.botChat(tab);
          sw = false;
        }
      }
      else {
        this.code = "599";
        this.region = "Region 1";
        // this.botChat(tab);
      }

      this.updatePostpaid.emit(this.postpago);
      this.updatePrepaid.emit(this.prepago);
      this.updateFixed.emit(this.telefoniaFijo);
      this.updateTotalAccountList.emit(this.totalAccountList);
      this.updateCurrentList.emit(this.currentList);
      sessionStorage.setItem("tab", tab);
      this.global.updateTypeAccount(this.currentAccountType);
      if (sw == true) {
        this.updateSelectBan.emit(this.selectBan);
      }


    }
  }
  botChat(tab){
    if(tab!=sessionStorage.getItem("tab")){
      this.token = sessionStorage.getItem("token");
      this.AccountInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
      // this.subscriber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField;
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.services.botchat(
        sessionStorage.getItem("token"),
        sessionStorage.getItem("SSOAccessToken"),
        this.region, this.code, "e2f7386f-32d3-44ed-8088-0133d1191124",
        this.origin, this.AccountInfo["firstNameField"] + " " + this.AccountInfo["lastNameField"],
        this.selectBan, this.AccountInfo["emailField"], "Web", "").subscribe(data => {
        if (data.hasError == false) {
          this.global.urlChat = data.url;
          sessionStorage.setItem("botChat",this.global.urlChat);
        }
      });
    }

  }
}
